import Svg, { SvgProps, Path } from 'react-native-svg'

export function ExpertGuidance({ ...props }: SvgProps) {
  return (
    <Svg width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}>
      <Path
        fill="#00DFC9"
        d="M19 12.5 17 9l-1-2.5-2.5 6-6.5 1 4.5 4.5-1.5 7 6-3.5 6.5 2.5-1-6 3-4.5-5.5-1Z"
      />
      <Path
        fill="#223843"
        d="m11.799 22.434 4.2-2.533 4.2 2.567-1.1-4.8 3.7-3.2-4.867-.434-1.933-4.533-1.934 4.5-4.866.433 3.7 3.234-1.1 4.766Zm4.2.6-5.534 3.334c-.244.155-.5.222-.766.2a1.288 1.288 0 0 1-.7-.267c-.2-.156-.356-.35-.467-.583a1.166 1.166 0 0 1-.067-.784l1.467-6.3-4.9-4.233a1.278 1.278 0 0 1-.367-1.433c.09-.245.223-.445.4-.6.178-.156.423-.256.734-.3l6.466-.567 2.5-5.933c.111-.267.284-.467.517-.6.233-.134.472-.2.717-.2.244 0 .483.066.716.2.234.133.406.333.517.6l2.5 5.933 6.467.567c.31.044.555.144.733.3.178.155.311.355.4.6a1.278 1.278 0 0 1-.367 1.433l-4.9 4.233 1.467 6.3c.067.29.044.55-.067.784A1.598 1.598 0 0 1 23 26.3c-.2.155-.434.244-.7.267a1.211 1.211 0 0 1-.767-.2l-5.533-3.334Z"
      />
    </Svg>
  )
}
